
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tym/[...params]",
      function () {
        return require("private-next-pages/tym/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tym/[...params]"])
      });
    }
  